const searchbar = () => {
    $(document).ready(function () {
        $('.icon-search').on('click', () => {
            $('.searchbar').fadeIn(200);
        });

        $('.close-icon').on('click', () => {
            $('.searchbar').fadeOut(200);
        });
    });
}

export default searchbar;